import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { AdUnitForProductTable } from '../types'
import { adUnitForProductTableFromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNITS } from './api/query'
import { AdUnitForProductTableDTO, Data, Variables } from './api/types'
import { Props, UseGetAdUnits } from './types'

export const useGetAdUnits = ({ domainId, filters, first, last, sort }: Props): UseGetAdUnits => {
  const ability = useAbility()
  const { workspaceId } = useWorkspaceParam()

  const [adUnits, setAdUnits] = useState<AdUnitForProductTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        adUnits: { nodes: adUnits, totalCount: count },
      } = data

      if (adUnits) {
        setAdUnits(
          adUnits.map(
            (node: AdUnitForProductTableDTO): AdUnitForProductTable =>
              adUnitForProductTableFromDTO(node),
          ),
        )
        setCount(count)
      }
    },
    query: GET_AD_UNITS(ability),
    variables: {
      domainId,
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return { adUnits, count, loading }
}
